export default {
  yes: 'Ja',
  no: 'Nein',

  info: 'Info',

  next: 'Weiter',
  back: 'Zurück',

  'action.skip': 'Überspringen',
  'action.open': 'Öffnen',

  'action.login': 'Anmelden',
  'action.login-register': 'Anmelden oder Registrieren',
  'action.show-more': 'Mehr anzeigen',
  'action.show-less': 'Weniger anzeigen',
  'action.accept-terms-and-conditions':
    'Ich habe die {anbs} gelesen, verstanden und akzeptiere diese.',
  'action.send-again': 'Erneut senden',
  'action.login-and-continue': 'Anmelden und fortfahren',
  'action.accept': 'Annehmen',
  'action.decline': 'Ablehnen',
  'action.switch-back': 'Zurück zu eigenem Konto wechseln',
  'action.delete': 'Löschen',
  'action.pause': 'Pausieren',
  'action.forgot-password': 'Passwort vergessen?',
  'action.reset-password': 'Passwort zurücksetzen',
  'action.save': 'Speichern',
  'action.cancel': 'Abbrechen',
  'action.confirm': 'Bestätigen',
  'action.logout': 'Abmelden',
  'action.search': 'Suchen',
  'action.open-in-maps': 'Standort anzeigen',
  'action.book-appointment': 'Termin buchen',
  'action.see-more-appointment-proposals': 'Weitere Terminvorschläge ansehen',

  'action.show-qr-code': 'Bitte zeigen Sie diesen Code bei der Aufnahme vor',
  'action.download': 'Herunterladen',

  'see-all': 'Alle ansehen',
  'register-now': 'Jetzt registrieren',

  'notice.data-privacy':
    'Hier finden Sie die aktuellen {dataPrivacyInformation} gemäß der Informationspflicht gem. Art. 13, 14 DSGVO.',
  'notice.data-privacy.privacy-information': 'Datenschutzinformationen',
};
